import { ref, computed } from "vue";
import { MyTaskDakokuData } from "@/types/Dakoku";

/*
 * 初期処理
 */
export function useInit() {
  const loading = ref(0); // APIで読み込みをする本数
  const isError = ref(false);

  // 承認が必要な打刻情報
  const form = ref<MyTaskDakokuData[]>([]);

  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value);
  });

  return {
    form,
    isLoading,
    isError,
  }
}
